import { render, staticRenderFns } from "./editTrainingRequest.vue?vue&type=template&id=b438681e&scoped=true"
import script from "./editTrainingRequest.vue?vue&type=script&lang=js"
export * from "./editTrainingRequest.vue?vue&type=script&lang=js"
import style0 from "./editTrainingRequest.vue?vue&type=style&index=0&id=b438681e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b438681e",
  null
  
)

export default component.exports